import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import padding from "@irati/ui/src/global/padding"
import HR from "@irati/ui/src/Layout/Hr"
import {greys} from "@irati/ui/src/global/colors"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  ${(props) => props.margin && `margin: 0 -${props.margin}`};
`

const Children = styled.div`
  padding: 0 ${padding.base};
  display: flex;
`

const StyledHR = styled(HR)`
  margin: 0;
  border-top: 2px solid ${greys.light};
`

const Menu = ({children, margin}) => {
  return (
    <Container margin={margin}>
      <Children>
        {children}
      </Children>
      <StyledHR />
    </Container>
  )
}

Menu.propTypes = {
  children: PropTypes.any.isRequired,
  margin: PropTypes.any
}

Menu.defaultProps = {
  margin: null
}

export default Menu
